import React from 'react';

const WorkerCard = ({ worker, onClick }) => (
  <div className="home-worker-card" onClick={onClick} style={{ cursor: 'pointer' }}>
    <img src={worker.avatar} alt="avatar" className="home-worker-avatar" />
    <div>
      <div className="home-worker-name">{worker.name}</div>
      <div className="home-worker-location">
        {worker.location} <span className="home-worker-rating">{worker.rating} <span style={{ color: '#f7b500' }}>★</span></span>
      </div>
      <div className="home-worker-prices">
        <span className="home-worker-old">₹{worker.oldPrice}</span>
        <span className="home-worker-new">₹{worker.newPrice}</span>
        <span className="home-worker-discount">{worker.discount}</span>
      </div>
    </div>
  </div>
);

export default React.memo(WorkerCard); 